import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-12 col-md-5 offset-md-1" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "medicare-part-a-effective-date" }, " Medicare Part A Effective Date ", -1 /* HOISTED */)
const _hoisted_4 = { class: "input-group date datepickerInput" }
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "coinsurance-amount" }, " Coinsurance Amount ", -1 /* HOISTED */)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "has-deductible-met" }, " Prior Authorization Required ", -1 /* HOISTED */)
const _hoisted_11 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "require-authorization",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "require-authorization",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "col-12 col-md-5"
}
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "out-of-pocket-amount" }, " Out-of-Pocket Maximum Amount ", -1 /* HOISTED */)
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "out-of-pocket-met" }, " Out-of-Pocket Maximum Met ", -1 /* HOISTED */)
const _hoisted_23 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "out-of-pocket-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "out-of-pocket-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_DatePicker, { getDate: _ctx.getDate }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("input", {
                type: "text",
                name: "medicare-part-a-effective-date",
                class: "form-control",
                value: _ctx.formatDateInput(_ctx.payer.medicarePartAEffectiveDate),
                placeholder: "MM/DD/YYYY",
                autocomplete: "off"
              }, null, 8 /* PROPS */, _hoisted_5),
              _hoisted_6
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["getDate"])
      ]),
      (_ctx.isApplicationPalliative)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                name: "coinsurance-amount",
                type: "text",
                placeholder: "Enter Coinsurance Amount",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payer.coinsuranceAmount) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.payer.coinsuranceAmount]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.requirePriorAuthorization ? 'active' : ''}`),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requireAuthorizationChanged(true)))
                  }, _hoisted_14, 2 /* CLASS */),
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.requirePriorAuthorization ? '' : 'active'}`),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.requireAuthorizationChanged(false)))
                  }, _hoisted_17, 2 /* CLASS */)
                ])
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.isApplicationPalliative)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              maxlength: "50",
              name: "out-of-pocket-amount",
              type: "text",
              placeholder: "Enter Out-of-Pocket Maximum Amount",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payer.outOfPocketMaxAmount) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.payer.outOfPocketMaxAmount]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", {
                  class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.isOutOfPocketMaxMet ? 'active' : ''}`),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.outOfPocketMaxMetChanged(true)))
                }, _hoisted_26, 2 /* CLASS */),
                _createElementVNode("label", {
                  class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.isOutOfPocketMaxMet ? '' : 'active'}`),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.outOfPocketMaxMetChanged(false)))
                }, _hoisted_29, 2 /* CLASS */)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}